var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('div',{staticClass:"loader_img"},[_c('img',{attrs:{"draggable":"false","src":require('../../assets/img/gif/pulse-loader.svg'),"alt":"loading...","height":"150","width":"150"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }